import {
  FormPageInputItem,
  FormPageInputItemMailRefusalFlag,
  FormPageInputItemMailRefusalFlagRadio,
  INPUT_ITEM_TYPE,
  MailRefusalFlagProperty,
  MAIL_REFUSAL_FLAG_PROPERTY_INPUT_TYPE,
} from 'shared';
import { MAIL_REFUSAL_FLAG_DEFAULT_VALUE } from '../../../../models';

const handleRadio = (
  formPageInputItem?: FormPageInputItem,
): FormPageInputItemMailRefusalFlagRadio => {
  const inputItemType = INPUT_ITEM_TYPE.mailRefusalFlagRadio;
  if (
    formPageInputItem?.inputItemType === INPUT_ITEM_TYPE.mailRefusalFlagRadio
  ) {
    return {
      inputItemType,
      isRefused: formPageInputItem.isRefused ?? MAIL_REFUSAL_FLAG_DEFAULT_VALUE,
    };
  }
  return {
    inputItemType,
    isRefused: MAIL_REFUSAL_FLAG_DEFAULT_VALUE,
  };
};

export const convertMailRefusalFlagInitialValue = (
  property: MailRefusalFlagProperty,
  formPageInputItem?: FormPageInputItem,
): FormPageInputItemMailRefusalFlag => {
  switch (property.inputFormat.inputType) {
    case MAIL_REFUSAL_FLAG_PROPERTY_INPUT_TYPE.radio: {
      return handleRadio(formPageInputItem);
    }
  }
};
